<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="custom-header font-weight-bold text-left">Encoder View List</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-4 text-left">
                <label >Select Crew : </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                      <i class="fa fa-search pr-2"></i>By All:
                    </button>

                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#" @click="setKey('all')" :class="{'active':params.searchKey == 'all'}">All</a>
                      <a class="dropdown-item" href="#" @click="setKey('last_name')" :class="{'active':params.searchKey == 'last_name'}">LastName</a>
                      <a class="dropdown-item" href="#" @click="setKey('first_name')" :class="{'active':params.searchKey == 'first_name'}">FirstName</a>
                      <a class="dropdown-item" href="#" @click="setKey('middle_name')" :class="{'active':params.searchKey == 'middle_name'}">MiddleName</a>
                    </div>
                  </div>

                  <input type="text"
                         id="crewStatus"
                         class="form-control form-control-sm"
                         v-model="params.searchValue"
                         v-on:input="searchCrew(1)"
                         :placeholder="keyPlaceHolder"
                         aria-label="Text input with dropdown button">
                </div>


              </div>

              <div class="col-md-2 text-left">
                <label >Hotel Type : </label>
                <select class="custom-select custom-select-sm" v-model="params.hotel_id" v-on:change="setHotel">
                  <option :value="null" selected>-- Choose --</option>
                  <option :value="1">TNKC</option>
                  <option :value="2">ZEN</option>
                </select>
              </div>


            </div>

          </div>

          <div class="card-body fs-13px">

            <div class="text-left">
              <small>
                {{ `${tnkcBookedPaganation.from} - ${tnkcBookedPaganation.to} of ${tnkcBookedPaganation.total}` }}</small>
            </div>
            <nav aria-label="..." class="pt-2">
              <ul class="pagination pagination-sm">
                <li class="page-item" :class="{ 'disabled': tnkcBookedPaganation.currentPage === 1}">
                  <button class="page-link" @click="setPage(1)">
                    <font-awesome-icon icon="step-backward"/>
                    First
                  </button>
                </li>

                <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === tnkcBookedPaganation.currentPage }">
                  <button class="page-link" @click="setPage(page)">{{ page }}</button>
                </li>

                <li class="page-item" :class="{ 'disabled': tnkcBookedPaganation.currentPage === tnkcBookedPaganation.lastPage}">
                  <button class="page-link" @click="setPage(tnkcBookedPaganation.lastPage)">
                    Last
                    <font-awesome-icon icon="step-forward"/>
                  </button>
                </li>
              </ul>
            </nav>
            <div class="table-responsive-sm fa-1x">
              <table class="table table-bordered" width="100%" cellspacing="0">
                <thead>
                  <tr class="bg-light">
                    <th scope="col" class="p-1 text-center">
                      <button id="reset" class="btn btn-sm tnkc-secondary" @click="refresh" data-toggle="tooltip" data-placement="top" data-html="true" title="Click to Refresh Data Table">
                        <font-awesome-icon icon="undo"/>
                      </button>
                    </th>
                  </tr>

                  <tr class="bg-light small">
                    <th scope="col" class="p-1 text-center" width="15px">#</th>
                    <th scope="col" class="p-1">Rank</th>
                    <th scope="col" class="p-1">Crew</th>
                    <th scope="col" class="p-1">Floor {{dash}} Room {{dash}} Bed</th>
                    <th scope="col" class="p-1">Booked Check-in</th>
                    <th scope="col" class="p-1">Booked Check-out</th>
                    <th scope="col" class="p-1">Actual Checkin</th>
                    <th scope="col" class="p-1">Actual Checkout</th>
                    <th scope="col" class="p-1">Status</th>
                    <th scope="col" class="p-1">UpdateBy</th>
                    <th scope="col" class="p-1 align-middle vert-aligned">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(booking,index) in bookings" :key="booking.booking_id">
                    <th scope="col">{{index + 1}}</th>
                    <td class="p-1 text-center small">{{booking.crew_rank}}</td>
                    <td class="p-1 text-left small">
                      <span>{{titleCase(booking.crew_name)}}</span>
                    </td>
                    <td class="p-1 small">{{booking.floor}}{{dash}}{{booking.room}}{{dash}}{{booking.bed}}</td>
                    <td class="p-1 small">{{ booking.booked_check_in | moment('D MMM YYYY')}}</td>
                    <td class="p-1 small">{{ booking.booked_check_out | moment('D MMM YYYY')}}</td>
                    <td class="p-1 small">{{ booking.actual_check_in | moment('D MMM YYYY')}}</td>
                    <td class="p-1 small">{{booking.actual_check_out | moment('D MMM YYYY')}}</td>
                    <td class="p-1 small">{{booking.booked_status}}</td>
                    <td class="p-1 small">{{booking.updatedBy}}</td>
                    <td class="vert-aligned">
                      <button class="btn btn-xsm btn-primary"
                              data-toggle="modal"
                              data-target="#bookedEncode"
                              data-backdrop="static"
                              data-keyboard="false"

                              v-on:click="view_booking_encode(booking.booking_id)">
                        view
                      </button>

                      <button class="btn btn-xsm btn-danger ml-2" v-on:click="deleteBookingDetails(booking.booking_id)">
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- todo modal here for the booking details view.-->
    <div class="modal fade" id="bookedEncode" tabindex="-1" role="dialog" aria-labelledby="bookedEncodeTitle" aria-hidden="true">
      <div class="modal-dialog  modal-dialog-centered" role="document">
        <div class="modal-content">
          <form v-on:submit.prevent="updateBookingDetails">
            <div class="modal-header">
              <h5 class="modal-title font-weight-bold" id="bookedEncodeTitle">{{titleCase(booked.crew_name)}}</h5>
              <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>-->
            </div>

            <div class="modal-body text-left">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <h5>  {{booked.floor}} {{dash}} {{booked.room}} {{dash}} {{booked.bed}}</h5>
                    </div>
                  </div>

                  <hr class="border">
                  <div class="row mt-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="bookedIn" class="font-weight-bold">Booked In :</label>
                        <div id="bookedIn" class="ml-4 border-bottom">
                          {{booked.booked_check_in | moment('D MMM YYYY')}}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="bookedOut" class="font-weight-bold">Booked Out :</label>
                        <div id="bookedOut" class="ml-4 border-bottom">
                          {{booked.booked_check_out | moment('D MMM YYYY')}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 border-left">
                      <div class="form-group">
                        <label class="font-weight-bold">
                          Actual Check-In :
                        </label>
                        <div  v-if="!isEditable" class="ml-4 border-bottom">
                           {{!booked.actual_check_in  ? '---' : booked.actual_check_in | moment('D MMM YYYY')}}
                         </div>
                        <input class="form-control form-control-sm" type="date" v-if="isEditable" v-model="dateCheckIn">
                      </div>

                      <div class="form-group">
                        <label class="font-weight-bold">Actual Check-Out :</label>
                        <div  v-if="!isEditable" class="ml-4 border-bottom">
                          {{!booked.actual_check_out ? '---'  : booked.actual_check_out | moment('D MMM YYYY')}}
                        </div>
                        <input type="date" class="form-control form-control-sm "  v-if="isEditable" v-model="dateCheckOut">
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" v-if="!isEditable" v-on:click="setBookedNull">Close</button>
              <button type="button" class="btn btn-warning" v-show="!isEditable" v-on:click="setEditBooked">Edit</button>
              <button type="button" class="btn btn-danger"  v-show="isEditable" v-on:click="setCancelUpdateBooked(booked.booking_id)">Cancel</button>
              <button type="submit" class="btn btn-primary" v-show="isEditable">Save Update</button>
            </div>
          </form>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {appMixins} from '@/mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';

import {LONG_DASH} from '@/service/constants.service';

export default {
  name: 'CustomEncoder',
  mixins: [appMixins],
  data() {
    return {
      isEditable: false,
      params:{
        page : '',
        searchValue : '',
        searchKey: 'all', //default
        count : 10,
        hotel_id: null,
      },
    };
  },
  methods: {
    ...mapActions(
        [
          'getAllBookingEncode',
          'setBookingsNull',
          'setResetTnkcBookedPagination',
          'viewBookingEncode',
          'setBookedNull',
          'updateBookingEncode',
          'deleteBookingEncode'
        ],
    ),

    view_booking_encode(obj){
      this.viewBookingEncode({booking_id: obj});
    },

  async  updateBookingDetails(obj = null) {
      if(await this.questionAlert('Are you sure you want to update this record.','Update Booking Details','question')){
       console.log('update booking details. ');
       this.updateBookingEncode(this.booked).then((res)=>{
         if(res==true){
           this.successAlert('Successfully Updated');
           $('#bookedEncode').modal('hide');
           this.searchCrew();
         }
       })
      }
    },

  async deleteBookingDetails(obj = null) {
      if(await this.questionAlert('Are you sure you want ot delete this record. ?','Delete Booking Details','warning')){
        console.log('delete booking details.');
        this.deleteBookingEncode(obj).then((res)=>{
          if(res==true){
            this.successAlert('Delete Successfully');
          }
        });
      }
    },

    searchCrew(initializePage = null){
      let page = (initializePage) ? initializePage : this.tnkcBookedPaganation.currentPage;
      this.params.page = page;
      this.getAllBookingEncode(this.params);
    },

    refresh(){
      this.searchCrew();
    },

    //key
    setKey(obj) {
      this.params.searchKey = obj;
      this.searchBy();
      this.searchCrew();
      // this.resetSList();
    },

    searchBy() {
      switch (this.params.searchKey) {
        case 'all':
          this.key = 'All';
          this.keyPlaceHolder = 'Search here ...';
          break;

        case 'last_name':
          this.key = 'LastName';
          this.keyPlaceHolder = 'Search Last Name here ...';
          break;

        case 'first_name':
          this.key = 'FirstName';
          this.keyPlaceHolder = 'Search First Name here ...';
          break;

        case 'middle_name':
          this.key = 'MiddleName';
          this.keyPlaceHolder = 'Search Middle Name here ...';
          break;

        case 'crewipn':
          this.key = 'CrewIPN';
          this.keyPlaceHolder = 'Search CrewIPN here ...';
          break;

        case 'rank':
          this.key = 'Rank';
          this.keyPlaceHolder = 'Search CrewRank here ...';
          break;
      }
    },

    //page
    setPage(page) {
      this.tnkcBookedPaganation.currentPage = page;
      this.searchCrew();
    },

    setCancelUpdateBooked(obj = null){
      this.viewBookingEncode({booking_id : obj});
      this.isEditable = !this.isEditable;
    },

    setEditBooked(){
      this.isEditable =  true;
    },

    setHotel(e){
      this.params.hotel_id = e.target.value;
      this.searchCrew();
    }
  },

  computed: {
    ...mapGetters(['bookings','tnkcBookedPaganation','booked']),

    paginationPages() {
      let pages = [];
      let currentPage = this.tnkcBookedPaganation.currentPage;
      let lastPage = this.tnkcBookedPaganation.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },

    dash(){
      return LONG_DASH;
    },

    dateCheckIn : {
      get : function(){
        return  this.booked.actual_check_in ?  this.formatDate(this.booked.actual_check_in) : null;
      },

      set : function(value) {
        this.booked.actual_check_in = value;
      }
    },

    dateCheckOut : {
      get : function(){
        return this.booked.actual_check_out ? this.formatDate(this.booked.actual_check_out) : null;
      },

      set : function(value){
         this.booked.actual_check_out = value;
      }
    }
  },

  created() {
    this.searchBy();
    this.searchCrew();
  },

  mounted() {},

  destroyed() {
    this.setBookingsNull();
    this.setResetTnkcBookedPagination();
  },
};
</script>

<style scoped>
.table tbody > tr > td.vert-aligned {
  vertical-align: middle;
  padding: 0 !important;
}

</style>
